import { render, staticRenderFns } from "./RiskyUsersModal.vue?vue&type=template&id=aa6a0296&scoped=true&"
import script from "./RiskyUsersModal.vue?vue&type=script&lang=ts&"
export * from "./RiskyUsersModal.vue?vue&type=script&lang=ts&"
import style0 from "./RiskyUsersModal.vue?vue&type=style&index=0&id=aa6a0296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a0296",
  null
  
)

export default component.exports